import { defineMessages } from 'react-intl';

export const messages: {
    title: {
        id: string;
        defaultMessage: string;
        description: string;
    }; totalItemsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; totalItemsDescription: {
        id: string;
        defaultMessage: string;
        description: string;
    }; pagesLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; workItemsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; videosLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; designsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; pullRequestsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; commentsLabel: {
        id: string;
        defaultMessage: string;
        description: string;
    }; topPercentileInsight: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	title: {
		id: 'twg-microsite-experience.v2.introduction.title',
		defaultMessage:
			'👋{br}G’day {username}, here’s an overview of the context the Teamwork Graph has created from your work over the last 12 months to help you work better with AI, every day.',
		description: 'Heading for the introduction section',
	},
	totalItemsLabel: {
		id: 'twg-microsite-experience.v2.introduction.totalItemsLabel',
		defaultMessage: 'Total items you captured',
		description: 'Label for the total items hero card',
	},
	totalItemsDescription: {
		id: 'twg-microsite-experience.v2.introduction.totalItemsDescription',
		defaultMessage:
			'Every work item, page, meeting, comment, and conversation quietly stitched together by your Teamwork Graph.',
		description: 'Description for the total items hero card',
	},
	pagesLabel: {
		id: 'twg-microsite-experience.v2.introduction.pagesLabel',
		defaultMessage: 'Pages',
		description: 'Label for the pages count stat card',
	},
	workItemsLabel: {
		id: 'twg-microsite-experience.v2.introduction.workItemsLabel',
		defaultMessage: 'Work items',
		description: 'Label for work items stat card',
	},
	videosLabel: {
		id: 'twg-microsite-experience.v2.introduction.videosLabel',
		defaultMessage: 'Videos',
		description: 'Label for the videos count stat card',
	},
	designsLabel: {
		id: 'twg-microsite-experience.v2.introduction.designsLabel',
		defaultMessage: 'Designs',
		description: 'Label for the designs count stat card',
	},
	pullRequestsLabel: {
		id: 'twg-microsite-experience.v2.introduction.pullRequestsLabel',
		defaultMessage: 'Pull requests',
		description: 'Label for pull requests stat card',
	},
	commentsLabel: {
		id: 'twg-microsite-experience.v2.introduction.commentsLabel',
		defaultMessage: 'Comments',
		description: 'Label for the comments count stat card',
	},
	topPercentileInsight: {
		id: 'twg-microsite-experience.v2.introduction.topPercentileInsight',
		defaultMessage: "You're in the top {percentile}% of your company's users",
		description: 'Insight card text showing the user is in the top N% of users',
	},
});
